import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["isField"];
import * as React from 'react';
import { ToggleGroup } from '@gandi/ui';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import FormGroup from '../decorators/FormGroup';
function ToggleGroupCompat(_props) {
  var isField = _props.isField,
    props = _objectWithoutProperties(_props, _excluded);
  // $FlowFixMe : Need children , made with decorateControl
  return /*#__PURE__*/React.createElement(ToggleGroup, props);
}
var component = decorateControl(ToggleGroupCompat, FormGroup);
var ToggleGroupField = function ToggleGroupField(props) {
  return /*#__PURE__*/React.createElement(FormField, _extends({}, props, {
    component: component
  }));
};
export default ToggleGroupField;